import * as React from "react";
import {Modal} from "antd";
import locales from "../locales";
import ClientRentalSummaryOverrideForm from "./ClientRentalSummaryOverrideForm";
import {ClientRentalSummary} from "../api/dtos/summaries";

interface Props {
  summary: ClientRentalSummary | undefined;
  onSubmit: () => void;
  onCancel: () => void;
  selectedYear: number;
  selectedMonth: number;
}

class ClientRentalSummaryOverrideModal extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {summary, onSubmit, onCancel, selectedYear, selectedMonth} = this.props;
    return (
      <Modal
        title={locales.override_values_for_given_month}
        visible={summary !== undefined}
        footer={null}
        onCancel={onCancel}
        width={600}
        destroyOnClose={true}
      >
        {summary && (
          <ClientRentalSummaryOverrideForm
            summary={summary}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
            onFormSubmit={onSubmit}
            onFormCancel={onCancel}
          />
        )}
      </Modal>
    );
  }

}

export default ClientRentalSummaryOverrideModal;


// WEBPACK FOOTER //
// ./src/summary/ClientRentalSummaryOverrideModal.tsx